<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-puzzle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.687 8.303C40.266 8.077 39.864 8 39.36 8h-6.611a8.003 8.003 0 00-15.496 0h-6.611c-.505 0-.906.077-1.328.303-.43.23-.78.58-1.01 1.01-.226.422-.303.823-.303 1.328v6.611a8.003 8.003 0 000 15.496v6.611c0 .505.077.907.303 1.328.23.43.58.78 1.01 1.01.422.225.823.303 1.328.303h28.718c.505 0 .907-.078 1.328-.303.43-.23.78-.58 1.01-1.01.225-.421.303-.823.303-1.328V29h-2a4 4 0 010-8h2V10.641c0-.505-.078-.906-.303-1.328-.23-.43-.58-.78-1.01-1.01zM29 12h9v5.252a8.003 8.003 0 000 15.496V38H12v-9h-2a4 4 0 010-8h2v-9h9v-2a4 4 0 018 0v2z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconPuzzle',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
